import React, { createContext, useContext, useState, useEffect } from 'react';
import { storage } from '../utils/storage';

const WorkModeContext = createContext();

const WORK_MODE_KEY = 'digital-menu-work-mode';

const WORK_MODE_CONFIG = {
  cashier: {
    labelKey: 'workMode.cashier',
    icon: 'point_of_sale',
    widgets: ['orders', 'cash', 'alerts'],
    dockExpanded: true,
  },
  waiter: {
    labelKey: 'workMode.waiter',
    icon: 'room_service',
    widgets: ['orders', 'tables'],
    dockExpanded: true,
  },
  manager: {
    labelKey: 'workMode.manager',
    icon: 'supervisor_account',
    widgets: ['alerts'],
    dockExpanded: false,
  },
  admin: {
    labelKey: 'workMode.admin',
    icon: 'admin_panel_settings',
    widgets: [],
    dockExpanded: false,
  },
};

export const WorkModeProvider = ({ children }) => {
  const [workMode, setWorkModeState] = useState(() => {
    const saved = storage.get(WORK_MODE_KEY);
    return saved && WORK_MODE_CONFIG[saved] ? saved : 'cashier';
  });

  const setWorkMode = (mode) => {
    if (WORK_MODE_CONFIG[mode]) {
      setWorkModeState(mode);
      storage.set(WORK_MODE_KEY, mode);
    }
  };

  const currentConfig = WORK_MODE_CONFIG[workMode];
  const visibleWidgets = currentConfig?.widgets || [];
  const dockExpanded = currentConfig?.dockExpanded ?? true;

  useEffect(() => {
    storage.set(WORK_MODE_KEY, workMode);
  }, [workMode]);

  const value = {
    workMode,
    setWorkMode,
    workModeConfig: currentConfig,
    visibleWidgets,
    dockExpanded,
    availableModes: WORK_MODE_CONFIG,
  };

  return <WorkModeContext.Provider value={value}>{children}</WorkModeContext.Provider>;
};

export const useWorkMode = () => {
  const context = useContext(WorkModeContext);
  if (!context) {
    throw new Error('useWorkMode must be used within a WorkModeProvider');
  }
  return context;
};

export default WorkModeContext;
